import { useEffect, useState } from "react";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import useWidgetToken from "../../data/useWidgetToken";
import LoadingWheel from "../../components/shared/LoadingWheel";
import { useAuth } from "../../contexts/AuthContext";
import useWebsites from "../../data/useWebsites";
import WebsiteCards, { SENDING_DOMAINS_ANCHOR } from "../../components/website/WebsiteCards";
import SendingDomainsCard from "../../components/website/SendingDomainsCard";

export default function AdminEmbed() {
    const { setInfo } = usePageNameContext();
    const { widgetToken } = useWidgetToken();
    // The impersonated customer's id while SAV is viewing as them, so embed codes point at the right widget
    const { customerId } = useAuth();
    const [isLoading, setIsLoading] = useState(true);
    const [token, setToken] = useState<string>("");

    const { websites, websitesQuery } = useWebsites();

    useEffect(() => {
        setInfo({
            name: "Websites",
            desc: "Manage your widgets, embed codes and sending addresses",
        });
    }, []);

    useEffect(() => {
        if (!widgetToken.isLoading && widgetToken.data && customerId) {
            setIsLoading(false);
            setToken(widgetToken.data.data);
        }
    }, [widgetToken.data, widgetToken.isLoading, customerId]);

    if (isLoading || !customerId) return <LoadingWheel />

    return (
        <div className="max-w-full px-4 pb-10">
            <div className="w-full mt-6">
                {websitesQuery.isLoading
                    ? <LoadingWheel />
                    : <WebsiteCards websites={websites} token={token} customerId={customerId} />}
            </div>

            <div id={SENDING_DOMAINS_ANCHOR} className="w-full mt-10 scroll-mt-6">
                <SendingDomainsCard />
            </div>
        </div>
    )
}
